import { render, staticRenderFns } from "./TermModuleSearch.vue?vue&type=template&id=67236dfd"
import script from "./TermModuleSearch.vue?vue&type=script&lang=js"
export * from "./TermModuleSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports